import { render, staticRenderFns } from "./CompaniesView.vue?vue&type=template&id=59240c52&scoped=true&"
import script from "./CompaniesView.vue?vue&type=script&lang=js&"
export * from "./CompaniesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59240c52",
  null
  
)

export default component.exports